import { graphql } from 'gatsby';
import React, { useEffect } from 'react';
import { Callout } from '../../components/Callout/Callout';
import { SmartLink } from '../../components/SmartLink/SmartLink';
import { AnalyticsController } from '../../layout/Analytics';
import { SEO } from '../../layout/SEO';
import { processMetatags } from '../../shared/metaTags';
import './LeadershipPage.scss';
import { helixAnalytics } from '../../shared/analytics/HelixAnalytics';

export default function LeadershipPage({ data, pageContext }) {
    const { nodeLeadership: page } = data;
    useEffect(() => {
        AnalyticsController.pageView({
            pageType: `Leadership Bio`,
        });
        helixAnalytics.trackPageView(
            data.nodeLeadership.title,
            `Leadership Bio`
        );
    }, []);

    return (
        <>
            {!pageContext.hideNav && (
                <nav className="leadership-nav kite-container">
                    {!page.field_board_of_directors && (
                        <SmartLink url="/leadership">All Leadership</SmartLink>
                    )}
                    <div>
                        <SmartLink url={pageContext.prev}>Prev</SmartLink>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <SmartLink url={pageContext.next}>Next</SmartLink>
                    </div>
                </nav>
            )}
            <Callout
                inputs={{
                    swapEyebrowOrder: true,
                    bgColor: `gray`,
                    imagePosition: `left`,
                    eyebrowText: page.field_leadership_position_title,
                    title: page.title,
                    isMainContent: true,
                    textContent: page.field_leadership_description?.value,
                    cta: page.relationships.field_ldr_headshot?.localFile
                        ? [
                              {
                                  title: `Download Profile Image`,
                                  uri: page.relationships.field_ldr_headshot
                                      ?.localFile?.publicURL,
                                  download: true,
                              },
                          ]
                        : [],
                    calloutImage: {
                        alt: `${page.title}'s headshot`,
                        gatsbyImage:
                            page.relationships.field_ldr_headshot?.localFile,
                        verticalAlign: `top`,
                    },
                }}
            />
        </>
    );
}

export const Head = ({ data }) => {
    const { nodeLeadership: page } = data;

    const leaderMetaDescription = () => {
        let descriptionTag = `${page.title} is ${page.field_leadership_position_title}, at Charter Communications. See ${page.title}'s career history, education, and memberships.`;
        page?.metatag
            ?.filter((tag) => tag.attributes?.name === `description`)
            .map((tag) => {
                if (tag.attributes?.content) {
                    descriptionTag = tag.attributes?.content;
                }
            });
        return descriptionTag;
    };

    const schema = `
        {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "name": "Charter Communications",
            "member": {
                "@type": "OrganizationRole",
                "member": {
                    "@type": "Person",
                    "name": "${page.title}"
                },
                "roleName": "${page.field_leadership_position_title}"
            }
        }
    `;

    return (
        <SEO location={page.fields.url} description={leaderMetaDescription()}>
            {processMetatags(page.metatag)}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: schema }}
            ></script>
        </SEO>
    );
};

export const query = graphql`
    query ($id: String!) {
        nodeLeadership(id: { eq: $id }) {
            field_board_of_directors
            field_edic
            field_featured
            field_featured_weight
            field_last_name
            title
            field_ldr_headshot {
                alt
            }
            field_leadership_description {
                value
            }
            fields {
                url
            }
            field_leadership_position_title
            field_top_leadership
            relationships {
                field_ldr_headshot {
                    localFile {
                        childImageSharp {
                            ...ImageConstrainedSettings
                        }
                        publicURL
                    }
                }
            }
            metatag {
                tag
                attributes {
                    content
                    href
                    name
                    rel
                    property
                }
            }
        }
    }
`;
